export const formatErrorForFirebase = (error) => {
  let message = error.split('/').pop().replace(/-/g, ' ').replace(/^\w/, char => char.toUpperCase());
  return message;
}